module.exports = require('./helpers/bundle-url').getBundleURL('au4zy') + "duplicate-box.393bd896.svg" + "?" + Date.now();